/**
 * AndVBar - 条形图组件
 * 基于 Ant Design Charts Bar
 */
import React from 'react';
import { Bar } from '@ant-design/plots';
import { withBaseChart, parseJsonProp } from '../base/BaseChart';
import type { AndVBarProps } from '../base/types';

// 使用 HOC 包装基础 Bar 组件
const BarWithBase = withBaseChart<AndVBarProps>(Bar, {
  chartType: 'AndVBar',
  defaultHeight: 300,
  defaultData: [
    { year: '1951 年', value: 38 },
    { year: '1952 年', value: 52 },
    { year: '1956 年', value: 61 },
    { year: '1957 年', value: 145 },
    { year: '1958 年', value: 48 },
  ],
});

/**
 * AndVBar 条形图组件
 */
export const AndVBar: React.FC<AndVBarProps> = (props) => {
  const {
    // 特有字段
    xField,
    yField,
    seriesField,
    colorField,
    // 布尔配置
    stack,
    group,
    percent,
    // JSON 配置
    conversionTag,
    markBackground,
    ...baseProps
  } = props;

  const chartProps: Record<string, any> = {
    ...baseProps,
  };

  // 添加字段配置 (如果存在)
  if (xField) chartProps.xField = xField;
  if (yField) chartProps.yField = yField;
  if (seriesField) chartProps.seriesField = seriesField;
  if (colorField) chartProps.colorField = colorField;

  // 添加布尔配置
  // 注意：字符串 "true"/"false" 需要转换，这里假设 BaseChart透传前已经处理？
  // 不，BaseChart只透传 restProps。我们需要手动处理布尔值
  // 简单起见，如果从设计器传过来可能是字符串，AntV可能支持字符串？
  // 安全起见，做个转换
  if (stack !== undefined) chartProps.stack = (stack as any) === true || (stack as any) === 'true';
  if (group !== undefined) chartProps.group = (group as any) === true || (group as any) === 'true';
  if (percent !== undefined) chartProps.percent = (percent as any) === true || (percent as any) === 'true';

  // 解析专用 JSON 配置
  const conversionTagConfig = parseJsonProp(conversionTag);
  if (conversionTagConfig !== undefined) chartProps.conversionTag = conversionTagConfig;

  const markBackgroundConfig = parseJsonProp(markBackground);
  if (markBackgroundConfig !== undefined) chartProps.markBackground = markBackgroundConfig;

  return <BarWithBase {...chartProps} />;
};

export type { AndVBarProps };
export default AndVBar;
